export default function PageLink({ page, ...props }) {
  return (
    <li key={page}>
      <p
        onClick={() => props.onPaginationClick(page)}
        className="flex items-center justify-center px-3 h-8 leading-tight text-green-600 hover:underline bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700 cursor-pointer"
      >
        {page}
      </p>
    </li>
  );
}
